import Axios from "../../configs/axios.config";

export const createSalaryStructure = (data) =>
  Axios.post(`/salary/salary-structure`, data).then((response) => response.data.data);
export const updateSalaryStructure = (data, id) =>
  Axios.put(`/salary/salary-structure/${id}`, data);
export const getSalaryStructureList = (data) =>
  Axios.get("/salary/salary-structure", { params: data }).then(
    (response) => response.data
  );
export const getSalaryStructureDetail = (id) =>
  Axios.get(`/salary/salary-structure/${id}`).then((response) => response.data.data);
export const deleteSalaryStructure = (id) =>
  Axios.delete(`/salary/salary-structure/${id}`);

export const assignSalaryStructure = (data) =>
  Axios.post(`/salary/salary-structure/assign`, data).then((response) => response.data.data);

// Get current active salary assignment for an employee
export const getCurrentSalary = (employeeId) =>
  Axios.get(`/salary/salary-structure/current/${employeeId}`).then((response) => response.data.data);

// Get salary assignment history for an employee
export const getSalaryHistory = (employeeId, params = {}) =>
  Axios.get(`/salary/salary-structure/assignments/${employeeId}`, { params }).then((response) => response.data);

